module.exports = __webpack_public_path__ + "static/media/project4.ec5529d2.png";